import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./../products/productDetail.css";
import EnableDisableModal from "../../components/modals/enableDisableModal";
import { enableDisableDivision } from "../../redux/actions/divisionAction";
import EnabledDisabledPopUp from "../../components/popups/EnabledDisabledPopUp";

const DivisionData = ({ data, index, currentPage, fetchdivisionList }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [onEnableShow, setOnEnableShow] = useState(false);
  const [userData, setUserData] = useState(null);
  const handleClose = () => setOnEnableShow(false);
  const [enabledDisable, setEnabledDisable] = useState(false);

  const user_type = localStorage.getItem("userType");
  useEffect(() => {
    if (user_type === "super_user") {
      const permissionData = JSON.parse(localStorage.getItem("permissions"));
      const permissionValue = permissionData?.find(
        (item) => item?.module_name === "Product" && item
      );

      setUserData(permissionValue);
    }
  }, []);

  const enableDisableFunc = (id) => {
    dispatch(
      enableDisableDivision(id, onEnableDisableSuccess, onEnableDisableError)
    );
  };

  const timeOutFnc = () => {
    setEnabledDisable(false);
    fetchdivisionList();
  };

  const onEnableDisableSuccess = (data) => {
    setEnabledDisable(true);
    console.log(data);
    setTimeout(timeOutFnc, 2000);
  };

  const onEnableDisableError = (err) => {
    console.log(err);
  };

  const reimbursementOptions = {
    "forward_cfa": "Full Order Forward from CFA",
    "order_off_qty": "Order Offer Quantity",
    "full_order_qty": "Full Order Quantity",
    "credit_note": "Credit Note for Offer"
  }

  return (
    <tr className="table-rows1">
      <td className="table-each-row-data">{(currentPage - 1) * 10 + index}</td>
      <td className="table-each-row-data">{data?.code ? data?.code : "--"}</td>
      <td className="table-each-row-data text-capitalize">{data?.name}</td>
      <td className="table-each-row-data text-capitalize">
        {data?.offer_type}
      </td>
      <td className="table-each-row-data text-capitalize">
        {data.reimbursement_method ? reimbursementOptions[data.reimbursement_method] : "--"}
      </td>
      <td className="table-each-row-data text-capitalize">
        {`${data?.order_limit} - ${data?.order_amount}`}
      </td>
      <td className="table-each-row-data text-capitalize">
        {data?.approval_level ? data?.approval_level : "--"}
      </td>
      <td className="table-each-row-data table-each-row-data-color-green">
        {data.status ? (
          <span style={{ color: "#24D626" }}>Active</span>
        ) : (
          <span style={{ color: "red" }}>Inactive</span>
        )}
      </td>
      <td className="table-each-row-data">
        <div className="all-button">
          <button
            className="button-view"
            type="button"
            onClick={() => navigate(`/division/view/${data.id}`)}
          >
            {"view"}
          </button>

          {(user_type == "super_user" && userData?.write) ||
            user_type == "vendor" ? (
            <>
              <span className="vr  vr_line mt-1 "></span>
              <button
                className="button-edit1"
                type="button"
                onClick={() => navigate(`/division/edit/${data.id}`)}
              >
                {"edit"}
              </button>
              <span className="vr vr_line mt-1"></span>
              {data.status ? (
                <button
                  className="button-disable"
                  type="button"
                  // bgColor={"red"}
                  color={"green"}
                  onClick={() => setOnEnableShow(true)}
                >
                  Disable
                </button>
              ) : (
                <button
                  className="button-enable"
                  type="button"
                  // bgColor={"red"}
                  color={"green"}
                  onClick={() => setOnEnableShow(true)}
                >
                  Enable
                </button>
              )}
              <EnableDisableModal
                enableDisableFunc={enableDisableFunc}
                handleClose={handleClose}
                title={`Division ${data?.code} ?`}
                id={data?.id}
                status={data?.status}
                show={onEnableShow}
              />
              <EnabledDisabledPopUp
                title={`Employee - ${data?.code}`}
                show={enabledDisable}
                status={data.status}
              />
            </>
          ) : (
            ""
          )}
        </div>
      </td>
    </tr>
  );
};

export default DivisionData;
